<style>
    .save-group-dropdown .dropdown-menu{
        width: 331px;
    }
    .save-group-dropdown .scroll-container{
        overflow-y: auto; 
        max-height: 322px;
    }
    .save-group-dropdown .group-dropdown-item{
        cursor: pointer;
        padding-left: 12px;
        padding-top: 8px;
        padding-bottom: 8px;
        /*margin: 8px 0;*/
        margin: 0px 0;
        /*transition: 0.1s;*/
        border-radius: 4px;
        font-size: 14px;
    }
    .save-group-dropdown .group-dropdown-item:hover{
        background: var(--border-color);
/*        background: var(--primary);
        color: white;*/
    }
    .save-group-dropdown .group-dropdown-item:last-child{
        margin-bottom: 0;
    }
    .save-group-dropdown .save-group-dropdown-button{
        padding: 7px 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /*max-width: 160px;*/
        max-width: 114px;
        font-weight: 600;
    }
</style>

<script>
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";

    export default {
        props: ['item'],
        data: function () {
            return {
                groups: {
                    data: [],
                    search: '',
                    loading: false,
                    load_more: true,
                    pagination: {
                        per_page: 100,
                        page: 1
                    },
                },
                selected_group: null
            };
        },
        mixins: [shopifyHelperMixin],
        components: {

        },
        created: function () {
            if(window.my_groups){
                this.groups.data = window.my_groups;
            }
            this.suggestGroup();
        },
        mounted: function () {
            var self = this;
            if(this.show){
                var dropdown = this.$el.querySelector('.dropdown-menu');
                if(dropdown){
                    this.initIntersection(dropdown, function(){
                        self.loadGroups();
                    });
                }
            }
            
            window.bus.$on('created-group', function(data){
                if(data.group && self.item === data.item){
                    self.setGroup(data.group);
                }
            });
        },
        computed: {
            show: function(){
                return !!this.auth_user;
            }
        },
        watch: {

        },
        methods: {
            loadGroups: function(){
                var self = this;
                if(window.my_groups){
                    this.groups.data = window.my_groups;
                } else {
                    this.getGroups();
                }
                self.suggestGroup();
            },
            getGroups: function(){
                var self = this;
                self.groups.loading = true;
                var url = '/api/v5/group';
                var params = {
                    search: this.groups.search,
                    per_page: this.groups.pagination.per_page,
                    page: this.groups.pagination.page
                };

                axios.get(url, {params: params}).then(function (response) {
                    var data = response.data.data;
                    if(!window.my_groups){
                        window.my_groups = data;
                    }
                    if(params.page === 1){
                        self.groups.data = data;
                    } else {
                        self.groups.data = self.groups.data.concat(data);
                    }
                    if(!data.length){
                        self.groups.load_more = false;
                    }
                    self.groups.loading = false;
                    self.suggestGroup();
                    self.$emit('loaded-groups', self.groups.data);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.groups.loading = false;
                    self.showErrorMessage(error);
                });
            },
            openCreateGroupModal: function(){
                window.bus.$emit('open-create-group-modal', {item: this.item});
            },
            toggleGroupItem: function(group){
                var self = this;

                self.groups.loading = true;
                var url = '/api/v5/group/' + group.uuid + '/toggle-item';
                var params = {
                    item: this.item
                };
                
                axios.post(url, params).then(function (response) {
                    var data = response.data.data;
                    Object.assign(group, data);
                    self.groups.loading = false;
                    self.$emit('updated-group', {
                        group: group
                    });
                    
                    self.showSavedSnackbar(group);
                    self.suggestGroup(group);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.groups.loading = false;
                    self.showErrorMessage(error);
                });
            },
            hasItem: function(group){
                var item_ids = group.item_ids || [];
                var id = this.item.id || this.item.uuid;
                return item_ids.includes(id);
            },
            suggestGroup: function(preferred_group){
                var selected_group = null;

                //Use the preferred group if it has this item
                if(preferred_group){
                    if(this.hasItem(preferred_group)){
                        selected_group = preferred_group;
                    }
                }
                
                if(!selected_group){
                    //Use the first group that has the item
                    for(var i=0; i < this.groups.data.length; i++){
                        var group = this.groups.data[i];
                        if(this.hasItem(group)){
                            selected_group = group;
                            break;
                        }
                    }
                }
                
                if(!selected_group){
                    //Use the preferred group if given one or use the first group in list
                    if(preferred_group){
                        selected_group = preferred_group;
                    } else {
                        selected_group =  this.groups.data[0];
                    }
                }

                this.setGroup(selected_group);
            },
            setGroup: function(group){
                this.selected_group = group;
                this.$emit('selected-group', this.selected_group);
            },
            showSavedSnackbar: function(group){
                var self = this;
                var item_ids = group.item_ids || [];
                var image_url = this.item.thumbnail || this.item.image_url;
                var snackbar = {
                    image_url: image_url,
                    pos: 'bottom-center'
                };

                if(item_ids.includes(this.item.id)){
                    snackbar.text = 'Saved to <br><strong>' + group.name + '</strong>';
                    snackbar.action_text = 'Undo';
                    snackbar.action_callback = function(){
                        self.toggleGroupItem(group);
                    };
                } else {
                    snackbar.text = 'Removed from <br><strong>' + group.name + '</strong>';
                }
                if(typeof RDSnackbar === 'object'){
                    RDSnackbar.show(snackbar);
                } else {
                    Snackbar.show(snackbar);
                }
            },
            getGroupImage: function(group){
                if(group && group.image_url){
                    if(group.image_url.includes('shopify.com')){
                        return this.resizeImage(group.image_url, '_64x');
                    }
                    return group.image_url;
                }
                return '/img/product_placeholder.png';
            }
        },
        filters: {

        }
    };
</script>

<template>
    <div class="dropdown save-group-dropdown d-inline-block" v-if="show">
        <button class="btn btn-default rounded-pill save-group-dropdown-button overlay-hide" type="button" data-toggle="dropdown" @click.prevent="1">
            <i class="fas fa-chevron-down fa-fw"></i>
            <span v-if="selected_group">{{selected_group.name}}</span>
        </button>
        <div class="dropdown-menu">
            <div class="px-3 pt-2">
                <div class="style-section-title text-center mb-2">Save to List</div>
                <div class="input-overlay-right mb-2" hidden>
                    <div class="overlay-content text-subtle">
                        <i class="fas fa-search fa-fw"></i>
                    </div>
                    <div class="w-100">
                        <input type="text" placeholder="Search for lists" v-model="groups.search" class="form-control">
                    </div>
                </div>
                <div class="scroll-container">
                    <div class="my-2">All Your Lists</div>
                    <div class="group-dropdown-item" v-for="(group, i) in groups.data" @click="toggleGroupItem(group)">
                        <div class="row no-gutters align-items-center">
                            <div class="col-auto">
                                <img class="fit-cover mr-2 lazyload" :data-src="getGroupImage(group)" height="48" width="48">
                            </div>
                            <div class="col">
                                {{group.name}}
                                <div class="text-subtle fs-12" v-if="hasItem(group)">Saved</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pointer p-3" @click="openCreateGroupModal">
                <i class="fas fa-plus fa-fw mr-1"></i>
                <span>Create List</span>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/group/saveGroupDropdown.vue